import { createAction, props } from '@ngrx/store';
import { IAvailableOffers, Offers, PreviewOffer } from '../../../core/models/offers.model';
import { Observable } from 'rxjs';

export const sendDeviceId = createAction('[Offers] Send Device Id');

export const successSendDeviceId = createAction('[Offers] Success Send Device Id');

// Offers by Merchant
export const getOffersByMerchant = createAction('[Offers] Get Offers By Merchants');

export const successGetOffersByMerchant = createAction(
  '[Offers] Success Get Offers By Merchants',
  props<{ offers: Offers[] }>()
);

export const failureGetOffersByMerchant = createAction(
  '[Offers] Failure Get Offers By Merchants',
  props<{ message: string }>()
);

export const setOfferAmount = createAction(
  '[Offers] Set Offer Amount',
  props<{ amount: string }>()
);

export const setNumberOfInstallments = createAction(
  '[Offers] Set Number of Installments',
  props<{ numberOfInstallments: number }>()
);

// Offer preview
export const getOfferPreview = createAction(
  '[Offers] Get Offer Preview',
  props<{ offersRequest: Array<Observable<PreviewOffer>> }>()
);

export const successGetOfferPreview = createAction(
  '[Offers] Success Get Offer Preview',
  props<{ previewOffers: PreviewOffer[] }>()
);

export const failureGetOfferPreview = createAction(
  '[Offers] Failure Get Offer Preview',
  props<{ message: string }>()
);

export const setPreviewOffer = createAction(
  '[Offers] Set Offer Preview',
  props<{ previewOffer: PreviewOffer }>()
);

export const setSelectedOfferId = createAction(
  '[Offers] Set Selected OfferId',
  props<{ offerId: string }>()
);

export const getOneOfferPreview = createAction('[Offers] Get One Offer Preview');

export const successOneOfferPreview = createAction(
  '[Offers] Success Get One Offer Preview',
  props<{ previewOffer: PreviewOffer }>()
);

export const failureOneOfferPreview = createAction(
  '[Offers] Failure Get One Offer Preview',
  props<{ message: string }>()
);

export const setOfferLoading = createAction('[Offers] Set Loading to False');

export const getAvailableOffers = createAction(
  '[Offers] Get Available Offers',
  props<{ transactionId: string }>()
);

export const successGetAvailableOffers = createAction(
  '[Offers] Success Get Available Offers',
  props<{ availableOffers: IAvailableOffers }>()
);

export const failureGetAvailableOffers = createAction(
  '[Offers] Failure Get Available Offers',
  props<{ error: string }>()
);

export const setSortedAvailableOffers = createAction(
  '[Offers] Set Sorted Available Offers',
  props<{ availableOffers: IAvailableOffers }>()
);

export const successSetSortedAvailableOffers = createAction(
  '[Offers] Success Set Sorted Available Offers',
  props<{ offers: Offers[] }>()
);

export const sendNewOfferIdForMaxInstallment = createAction(
  '[Offers] Send New Offer Id For Max Installment',
  props<{ offerId: string }>()
);

export const successSendNewOfferIdForMaxInstallment = createAction(
  '[Offers] Success Send New Offer Id For Max Installment'
);

export const failureSendNewOfferIdForMaxInstallment = createAction(
  '[Offers] Failure Send New Offer Id For Max Installment',
  props<{ error: string }>()
);

export const setPreviousInstallmentsSelected = createAction(
  '[Offers] Set Previous Installments Selected',
  props<{ previousInstallmentsSelected: number }>()
);
